import pluralize from 'pluralize'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { stringifyDate, useListData } from '../../modules'

import Receive from "../../components/reusable/receive"

const ExpiringSoon = ({ store }) => {
    const { params, lastInventoryAlert } = useSelector(state => state.application)
    const thresholdDays = params?.inventoryNearExpiryThresholds?.[0] ?? 30

    const [
        { loading, error, fetch },
        { list: items },
        { Paginate, page = 1, limit = 10 }
    ] = useListData('nearExpiryItems', {
        store: store?._id,
        thresholdDays
    }, { notify: true }, 'items')

    useEffect(() => {
        if (!store?._id || !lastInventoryAlert) return
        if (lastInventoryAlert.type !== 'near-expiry-alert') return
        if (lastInventoryAlert.storeId !== store._id && lastInventoryAlert.destination !== store.name) return
        fetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastInventoryAlert, store?._id, store?.name])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <div>
                        <h2 className="font-semibold text-gray-800">Expiring Soon</h2>
                        <p className="text-xs text-gray-500 italic">Showing batches due within {thresholdDays} day(s)</p>
                    </div>
                </header>
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <Receive error={error} loading={loading} progress>
                            {
                                items.length > 0 ?
                                    <table className="table-auto w-full">
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2"><div className="font-semibold text-center">No</div></th>
                                                <th className="p-2"><div className="font-semibold text-left">Item</div></th>
                                                <th className="p-2"><div className="font-semibold text-left">Batch</div></th>
                                                <th className="p-2"><div className="font-semibold text-left">Quantity</div></th>
                                                <th className="p-2"><div className="font-semibold text-left">Expiry</div></th>
                                                <th className="p-2"><div className="font-semibold text-left">Status</div></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                items.map((item, key) => {
                                                    const expired = item?.expiryStatus === 'expired'
                                                    return (
                                                        <tr key={item._id}>
                                                            <td className="p-2"><div className="text-center">{((page - 1) * limit) + key + 1}.</div></td>
                                                            <td className="p-2"><div>{item?.item?.name ?? item?.name}</div></td>
                                                            <td className="p-2"><div>{item?.batchNo || '—'}</div></td>
                                                            <td className="p-2"><div>{item?.total} {pluralize(item?.item?.issuedIn, item?.total)}</div></td>
                                                            <td className="p-2"><div>{stringifyDate(item?.expiry, true)}</div></td>
                                                            <td className="p-2">
                                                                <span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${expired ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                                                                    {expired ? `Expired ${Math.abs(item?.daysToExpiry)} day(s) ago` : `Expires in ${item?.daysToExpiry} day(s)`}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="text-center my-8 text-gray-500">
                                        No batches are due within {thresholdDays} day(s).
                                    </div>
                            }
                        </Receive>
                    </div>
                    <div className="mt-4">
                        <Paginate />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExpiringSoon
